import differenceInMinutes from "date-fns/difference_in_minutes";

export default class EntryModel {
    constructor(id, activity, begin, end, project, phase) {
        this.id = id;
        this.activity = activity;
        this.begin = begin;
        this.end = end;
        this.project = project;
        this.phase = phase;
    }

    get duration() {
        return differenceInMinutes(this.end, this.begin) / 60;
    }
}



// WEBPACK FOOTER //
// ./src/models/entry.js